import Image from "@/components/AppImage";
import privacy_cookies from "/public/img/privacy-cookies.png";

const PrivacyConten = () => {
  return (
    <section className="privacy-content">
      <div className="overlay pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="top-wrapper">
                <h4>
                  We&#39;re always looking for new ways to provide privacy for
                  our customers.
                </h4>
                <p>
                  Id ipsum mi tempor eget. Pretium consectetur scelerisque
                  blandit habitasse non ullamcorper enim, diam quam id et,
                  tempus massa. Sed nam vulputate pellentesque quis. Varius a,
                  nunc faucibus proin elementum id odio auctor. Nunc,
                  suspendisse consequat libero, pharetra tellus vulputate auctor
                  venenatis tortor non rhoncus at duis. Pharetra ipsum mauris
                  integer sit feugiat.
                </p>
                <ul>
                  <li>
                    — Blandit dignissim nulla varius tristique a sed integer ut
                    tempor.
                  </li>
                  <li>— Augue interdum semper bibendum amet sed.</li>
                  <li>— Dis in at ultricies tortor sit tellus.</li>
                  <li>— Habitant ornare aenean maecenas pretium</li>
                </ul>
                <p>
                  Eget purus aenean sit risus. Arcu, aliquam eget et viverra
                  risus purus. Commodo fames tristique dui pharetra elit aliquet
                  morbi. Eget consectetur risus nunc lorem sit consequat
                  aliquet. Dolor velit consectetur etiam scelerisque. Integer
                  interdum sodales scelerisque diam massa quam sit quis. Sed et
                  dui a nam pulvinar. Tristique justo, donec lectus vitae,
                  cursus ligula ridiculus lacus, tincidunt. Diam dictumst
                  faucibus dui aliquet aenean nascetur feugiat leo. Etiam
                  dignissim orci dignissim vitae.
                </p>
                <div className="safe-data">
                  <h4>
                    Your data is safe with us, we will not share any information
                    with external sources.
                  </h4>
                  <p>
                    Blandit dignissim nulla varius tristique a sed integer ut
                    tempor. Augue interdum semper bibendum amet sed. Dis in at
                    ultricies tortor sit tellus. Habitant ornare aenean maecenas
                    pretium, dui ullamcorper quis. Egestas viverra et id aliquet
                    faucibus rhoncus a. Sollicitudin nisl nulla tempor pretium
                    lorem at mauris faucibus pulvinar.
                  </p>
                  <ul>
                    <li>
                      Eget purus aenean sit risus. Arcu, aliquam eget et viverra
                      risus purus. Commodo fames tristique dui pharetra elit
                      aliquet morbi.
                    </li>
                    <li>
                      Eget consectetur risus nunc lorem sit consequat aliquet.
                      Dolor velit consectetur etiam scelerisque.
                    </li>
                    <li>
                      Integer interdum sodales scelerisque diam massa quam sit
                      quis. Sed et dui a nam pulvinar. Tristique justo, donec
                      lectus vitae, cursus ligula ridiculus lacus, tincidunt.
                    </li>
                    <li>
                      Diam dictumst faucibus dui aliquet aenean nascetur feugiat
                      leo. Etiam dignissim.
                    </li>
                    <li>
                      {" "}
                      Aliquam eget et viverra risus purus. Commodo fames
                      tristique dui pharetra elit aliquet morbi.
                    </li>
                  </ul>
                </div>
                <div className="cookies">
                  <h4>Cookies and tracking</h4>
                  <p>
                    Consequat mauris nunc congue nisi. Cursus metus aliquam
                    eleifend mi in nulla. Dignissim cras tincidunt lobortis
                    feugiat vivamus. Blandit aliquam etiam erat velit. Sapien
                    faucibus et molestie ac. Ornare aenean euismod elementum
                    nisi quis eleifend quam adipiscing vitae. Id cursus metus
                    aliquam eleifend mi in nulla posuere sollicitudin.
                  </p>
                  <div className="img-area text-center text-md-start">
                    <Image src={privacy_cookies} alt="image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyConten;
